import { Phone } from "lucide-react";
import { scrollToSection } from "@/App";

export default function Header() {
  return (
    <header
      data-testid="site-header"
      className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-[#5b676f]/70 border-b border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-[72px] flex items-center justify-end">
        <div className="flex items-center gap-6">
          <span
            data-testid="header-rbq"
            className="hidden lg:block text-xs uppercase tracking-[0.15em] text-[#C4C9CE]"
          >
            RBQ : Q:5881-6240-01
          </span>
          <a
            data-testid="header-phone-link"
            href="tel:4389851797"
            className="hidden sm:flex items-center gap-2 text-sm text-[#F9F9F9] hover:text-[#D1BFAE] transition-colors duration-300"
          >
            <Phone size={15} strokeWidth={1.5} />
            438-985-1797
          </a>
          <button
            data-testid="header-quote-cta"
            onClick={() => scrollToSection("soumission")}
            className="relative overflow-hidden border border-[#D1BFAE]/60 px-5 py-2.5 text-xs uppercase tracking-[0.15em] text-[#D1BFAE] group"
          >
            <span className="absolute inset-0 bg-[#D1BFAE] translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" />
            <span className="relative group-hover:text-[#1a1a1a] transition-colors duration-300">
              Soumission gratuite
            </span>
          </button>
        </div>
      </div>
    </header>
  );
}
